export default function initDestaques() {
    const items = document.querySelectorAll('.c-destaques__item');
    if (!items.length) return;

    // Define o breakpoint do seu Desktop (ajuste o 992px se o seu 'md' for outro valor, tipo 992px)
    const mediaQuery = window.matchMedia('(min-width: 992px)');

    function handleScreenChange(e) {
        if (e.matches) {
            // Se for Desktop: Abre todos!
            items.forEach(item => item.setAttribute('open', 'open'));
        } else {
            // Se for Mobile: Fecha todos!
            items.forEach(item => item.removeAttribute('open'));
        }
    }

    // Roda a função assim que a página carrega
    handleScreenChange(mediaQuery);

    // Fica "escutando" caso o usuário redimensione a janela do navegador
    mediaQuery.addEventListener('change', handleScreenChange);
}